import React from "react";

import Modal from "./components/Modal/";
import { withAppStore } from "./context/index";

import "./styles/app.scss";

export default withAppStore(() => {
  return <Modal />;
});
